<template>
  <div class="select-wrapper">
    <v-select
      @change="selectChanged"
      :items="selectOptions"
      v-model="selected"
      :item-disabled="disableItemHandler"
    >
      <template v-slot:item="{ item }">
        <span class="text-xs-no-wrap">
          <AppPeriod :start="item.startTime" :end="item.endTime" is-date />
        </span>
      </template>
      <template v-slot:selection="{ item }">
        <span class="text-xs-no-wrap">
          <AppPeriod :start="item.startTime" :end="item.endTime" is-date />
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { actions } from '@/vuex/modules/progressReport/constants'
import _sortBy from 'lodash/sortBy'
import checkInvalidBPItem from '@/components/Advertiser/Report/BudgetProgressReport/checkInvalidBPItem'

export default {
  name: 'PeriodSelector',
  props: {
    bpIds: Array,
    ioId: Number,
  },
  data(vm) {
    return {
      selected: vm.bpIds.find(bp => bp.selected),
    }
  },
  computed: {
    selectOptions() {
      return _sortBy(this.bpIds, ['startTime'])
    },
  },
  methods: {
    disableItemHandler(bp) {
      return checkInvalidBPItem(bp)
    },
    selectChanged() {
      this.$store.dispatch(actions.CHANGE_BP, {
        IOId: this.ioId,
        BPId: this.selected.BPId,
        advertiserId: this.$route.params.advertiserId,
      })
    },
  },
}
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
}

.v-input >>> .v-input__control .v-text-field__details {
  display: none;
}

.v-text-field__details {
  display: none;
  height: 0;
}
</style>
